import React, { useEffect, useState } from "react";
import axios from "axios";
import { settings } from "../../helpers/settings";
import authHeader from "../../helpers/functions/auth-header";
import { encryptedLocalStorage } from "../../helpers/functions/encrypt-storage";
import { Link } from "react-router-dom";
const AccountingReport = () => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("all");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState(null); // Başlangıçta null, boş olacak

  // Kullanıcı listesini çek
  useEffect(() => {
    axios
      .get(`${settings.apiURL}/get_all_users.php`, { headers: authHeader() })
      .then((res) => {
        setUsers(res.data.users);
      })
      .catch((err) => {
        console.error(err);
        alert("Failed to fetch user list.");
      });
  }, []);

  const fetchReport = () => {
    setLoading(true);
    let url = `${settings.apiURL}/get_accounting_report.php?user_id=${selectedUser}`;
    if (month) url += `&month=${month}`;
    if (year) url += `&year=${year}`;

    axios
      .get(url, { headers: authHeader() })
      .then((res) => {
        const responseData = res.data.data || [];
        setData(responseData);

        // Özet hesapla
        let totalFiles = 0;
        let totalInch = 0;
        responseData.forEach((user) => {
          user.files.forEach((file) => {
            totalFiles++;
            totalInch += parseFloat(file.inch_height || 0);
          });
        });
        setSummary({ totalFiles, totalInch });
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        alert("Rapor alınamadı.");
        setLoading(false);
      });
  };

  const downloadExcel = () => {
    const token = encryptedLocalStorage.getItem("token");
    let url = `${settings.apiURL}/download_accounting_report.php?user_id=${selectedUser}&token=${token}`;
    if (month) url += `&month=${month}`;
    if (year) url += `&year=${year}`;
    window.open(url, "_blank");
  };

  const getSelectedUserName = () => {
    if (selectedUser === "all") return "Tüm Kullanıcılar";
    const foundUser = users.find((u) => u.id === selectedUser);
    return foundUser ? `${foundUser.first_name} ${foundUser.last_name}` : "";
  };

  return (
    <div className="container mt-4">
      {/* ✅ HOME butonu sağ üst köşe */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Accounting Report</h2>
        <Link to="/home" className="btn btn-outline-primary">
          🏠 Home
        </Link>
      </div>

      <div className="d-flex gap-2 mb-3">
        <select
          className="form-select w-auto"
          value={selectedUser}
          onChange={(e) => setSelectedUser(e.target.value)}
        >
          <option value="all">All Users</option>
          {users.map((user) => (
            <option key={user.id} value={user.id}>
              {user.first_name} {user.last_name}
            </option>
          ))}
        </select>

        <select
          className="form-select w-auto"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
        >
          <option value="">Ay Seç</option>
          {[...Array(12)].map((_, i) => (
            <option key={i + 1} value={i + 1}>
              {i + 1}
            </option>
          ))}
        </select>

        <select
          className="form-select w-auto"
          value={year}
          onChange={(e) => setYear(e.target.value)}
        >
          <option value="">Pick Year</option>
          {[2026, 2025, 2024, 2023].map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>

        <button className="btn btn-primary" onClick={fetchReport}>
          Get Report
        </button>
        <button className="btn btn-success" onClick={downloadExcel}>
          Download PDF
        </button>
      </div>

      {/* Özet Bilgisi */}
      {summary && (
        <div className="row g-3 mb-3">
          <div className="col-md-6">
            <div className="p-3 border bg-light">
              <strong>Toplam Yüklenen Dosya:</strong>{" "}
              {summary.totalFiles.toLocaleString("tr-TR")}
            </div>
          </div>
          <div className="col-md-6">
            <div className="p-3 border bg-light">
              <strong>Total Height (inch):</strong>{" "}
              {summary.totalInch.toLocaleString("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
        </div>
      )}

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>User</th>
              <th>File Name</th>
              <th>Width (inch)</th>
              <th>Height (inch)</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {data.flatMap((user) =>
              user.files.map((file, i) => (
                <tr key={`${user.user}-${i}`}>
                  <td>{user.user}</td>
                  <td>{file.file_name}</td>
                  <td>{file.inch_width}</td>
                  <td>{file.inch_height}</td>
                  <td>{file.uploaded_date}</td>
                </tr>
              )),
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AccountingReport;
